var styles = {
  "RadioButton": "Polaris-RadioButton",
  "Input": "Polaris-RadioButton__Input",
  "Backdrop": "Polaris-RadioButton__Backdrop",
  "hover": "Polaris-RadioButton--hover"
};

export { styles as default };
